import React from 'react';
import { ThemeProvider } from 'react-bootstrap';
import { MainView } from './components/MainView';
import { getDomainCfg, store } from './core/state';
import { VIEW_DATA } from './core/constants';
import { getCurrentTheme, setTheme } from './components/ThemeContext';

export const AppView: React.FC = () => {
  const [viewState] = store.useState(VIEW_DATA);

  React.useEffect(() => {
    if (viewState.initialized) {      
        setTheme(getCurrentTheme());
    }
  }, [viewState.initialized, viewState.currentView]);

  return (
    <ThemeProvider>
      <MainView />
    </ThemeProvider>
  );
};
